'use strict';

var videoPlayer = function () {
  var playButton = document.getElementById("js-play"),
      video = document.getElementById('js-video');

      if( playButton && video) {

        // Event listener for the play/pause button
        playButton.addEventListener("click", function() {

          if (video.paused == true) {
            // Play the video

            video.play();
            playButton.classList.add('c-Play--pressed');
            video.controls = true;

          } else {
            // Pause the video
            //playButton.classList.remove('c-Play--pressed');
            video.pause();

          }
        });

      }


};

module.exports = videoPlayer;
